import { registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import { rewardClaimsDataProvider } from './dataProvider';

export function initRewardClaimsDataProvider() {
  registerModuleDataProvider('agent-reward-claims', rewardClaimsDataProvider);
}

initRewardClaimsDataProvider();
